import { AppShowType } from "./constants/app.constant"
import { Country } from "./constants/env.constant"

export const DefaultAppData: Window['bridgeData'] = {
  onClose: () => { },
  showType: AppShowType.Page,
  data: {
    props: {},
    user: {
      language: 'en',
      region: (process.env.APP_REGION as Country) || Country.id,
      shopeeToken: process.env.APP_TOKEN || '',
      userId: 0,
    },
  },
}
